import { SiteContainer as BaseSiteContainer } from "@packsize/components";
import { Outlet } from "react-router-dom";

import { ErrorsAndWarningsProvider } from "@/contexts/errors-and-warnings";

import { PacknetNavbar } from "../navbar";

export const SiteContainer = () => {
	return (
		<ErrorsAndWarningsProvider>
			<BaseSiteContainer header={<PacknetNavbar />}>
				<Outlet />
			</BaseSiteContainer>
		</ErrorsAndWarningsProvider>
	);
};
